import { Tracker } from "../types";

type TrackersPagePageState = {
    pager_page: number;
    pager_total_length: number;
    pager_filtered_length: number;
    pager_page_size: number;
}

const EmptyPager: TrackersPagePageState = {
    pager_page: 0,
    pager_total_length: 0,
    pager_filtered_length: 0,
    pager_page_size: 20,
};

const LOCALSTORAGE_PAGER_KEY = 'RedirectionPager';
const item = localStorage.getItem(LOCALSTORAGE_PAGER_KEY);

const PAGER: TrackersPagePageState = item ? JSON.parse(item) : {
    ...EmptyPager
}

function isCurrentPage(tracker: Tracker, index: number): boolean {
    if (PAGER.pager_page_size > 0 && index < PAGER.pager_page * PAGER.pager_page_size) {
        return false;
    }
    if (PAGER.pager_page_size > 0 && index >= (PAGER.pager_page+1) * PAGER.pager_page_size) {
        return false;
    }
    return true;
}

function setLength(total: number, filtered: number) {
    PAGER.pager_total_length = total;
    PAGER.pager_filtered_length = filtered;
    changePage(0);
}

function changePage(sens: number) {
    const pager_page_last = Math.ceil(PAGER.pager_filtered_length / PAGER.pager_page_size)
    PAGER.pager_page = Math.max(0, Math.min(pager_page_last-1, PAGER.pager_page + sens));
    localStorage.setItem(LOCALSTORAGE_PAGER_KEY, JSON.stringify(PAGER))
}

function changePerPage(perPage: number) {
    PAGER.pager_page = 0;
    PAGER.pager_page_size = perPage;
    localStorage.setItem(LOCALSTORAGE_PAGER_KEY, JSON.stringify(PAGER))
}

function getCurrentPage() {
    return PAGER.pager_page
}

function getLastTotalPage() {
    return Math.ceil(PAGER.pager_total_length / PAGER.pager_page_size);
}

function getLastFilteredPage() {
    // console.log(PAGER.pager_filtered_length)
    return Math.ceil(PAGER.pager_filtered_length / PAGER.pager_page_size);
}

function getPageSize() {
    return PAGER.pager_page_size;
}

const PagerService = {
    isCurrentPage,
    setLength,
    changePage,
    changePerPage,
    getCurrentPage,
    getLastTotalPage,
    getLastFilteredPage,
    getPageSize,
}

export default PagerService;
